<template>
  <div :class="['base-info-block', typeClass]">
    <MaterialIcon
      v-if="iconName"
      :size="17"
      class="mt-[2px] flex-shrink-0"
    >
      {{ iconName }}
    </MaterialIcon>
    <slot />
  </div>
</template>

<script>
import MaterialIcon from '@/components/MaterialIcon.vue'

export default {
  name: 'BaseInfoBlock',
  components: { MaterialIcon },
  props: {
    type: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'danger', 'warning', 'info'].includes(v),
    },
  },
  computed: {
    typeClass () {
      const map = {
        default: 'bg-gray-20 text-gray-60',
        danger: 'bg-danger-light text-danger',
        warning: 'bg-warning-light text-warning',
        info: 'bg-info-light text-info',
      }
      return map[this.type] || map.default
    },
    iconName () {
      const map = {
        default: '',
        danger: 'error_outline',
        warning: 'warning',
        info: 'info',
      }
      return map[this.type] || ''
    },
  },
}
</script>

<style lang="postcss" scoped>
.base-info-block {
  @apply flex items-start gap-[6px] rounded-[4px] px-[12px] py-[10px];
}
</style>
